/* Blossom Setting - Dutch Marquise collection hover fix.
   The collection card's secondary/hover image is hard-coded to product.media[1]
   (a fixed yellow isometric) and the .changeele swatch handler only swaps the
   MAIN image, never the hover image. This makes the hover image metal-aware for
   the Blossom Dutch Marquise card only: it derives the matching perspective
   render from the BL-DutchMarquise-<Metal>-cover filename (White uses persp2),
   on both initial load and swatch click. Scoped entirely by the filename, so no
   other product/shape is affected. */
(function () {
  if (window.__blossomDMHover) return;
  window.__blossomDMHover = true;
  var CDN = 'https://cdn.shopify.com/s/files/1/0708/5876/8690/files/';
  function perspFromCover(url) {
    if (!url) return null;
    var file = url.split('?')[0];
    file = file.substring(file.lastIndexOf('/') + 1);
    var m = file.match(/BL-DutchMarquise-(Yellow|White|Rose)-cover/i);
    if (!m) return null;
    var metal = m[1].charAt(0).toUpperCase() + m[1].slice(1).toLowerCase();
    var name = (metal === 'White') ? 'White-persp2' : (metal + '-persp');
    return CDN + 'BL-DutchMarquise-' + name + '.webp';
  }
  function setSecondary(card, coverUrl) {
    if (!card) return;
    var url = perspFromCover(coverUrl);
    if (!url) return;
    var sec = card.querySelector('img.secondary');
    if (sec) { sec.removeAttribute('srcset'); sec.setAttribute('src', url); }
  }
  function initAll() {
    document.querySelectorAll('.product-card').forEach(function (card) {
      var main = card.querySelector('.custmainimg');
      if (main) setSecondary(card, main.getAttribute('src'));
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('.changeele[data-variant-image]');
    if (!sw) return;
    var cover = sw.getAttribute('data-variant-image');
    if (!cover || !/BL-DutchMarquise-(Yellow|White|Rose)-cover/i.test(cover)) return;
    setSecondary(sw.closest('.product-card'), cover);
  }, false);
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
